const REQUEST = "REQUEST";
const LOADING = "LOADING";
const SUCCESS = "SUCCESS";
const FAILURE = "FAILURE";
const RESET = "RESET";

const suffixTypes = [REQUEST, LOADING, SUCCESS, FAILURE, RESET];

function createRequestTypes(prefix = "", bases, suffixes = suffixTypes) {
  const req = {};
  bases.forEach((base) => {
    suffixes.forEach((suffix) => {
      req[`${base}_${suffix}`] = `${prefix}_${base}_${suffix}`;
    });
  });
  return req;
}

//sava application expected api states
export const OP = createRequestTypes(
  "OP",
  [
    // OP
    "LOGIN",
    "OTP",
    "FORGET_PASSWORD",
    "CHANGE_PASSWORD",

    "DASHBOARD",
    "TRANSACTIONS",
    "NOTIFICATIONS",
    "LOGS",

    "STAFF_LIST",
    "ADD_STAFF",
    "VIEW_STAFF",
    "EDIT_STAFF",
    "ACTIVATE_STAFF",
    "DEACTIVATE_STAFF",
    "APPROVE_STAFF",
    "REJECT_STAFF",
    "RESET_STAFF_PASSWORD",
    "UNBLOCK_STAFF",

    "PARTNER_LIST",
    "ADD_PARTNER",
    "VIEW_PARTNER",
    "EDIT_PARTNER",
    "ACTIVATE_PARTNER",
    "DEACTIVATE_PARTNER",
    "APPROVE_PARTNER",
    "REJECT_PARTNER",
    "GET_ACTIVE_PARTNERS",
    "GET_LOGGED_IN_PARTNER_DETAILS",
    "UPLOAD_PARTNER_PHOTO",
    "GET_PARTNER_AGENTS",

    "AGENT_LIST",
    "ADD_AGENT",
    "VIEW_AGENT",
    "EDIT_AGENT",
    "ACTIVATE_AGENT",
    "DEACTIVATE_AGENT",
    "APPROVE_AGENT",
    "REJECT_AGENT",
    "AGENT_COMMISSION_SUMMARY",
    "AGENT_COMMISSIONS",
    "AGENT_COMMISSIONS_BY_DATE",

    "AGENT_STAFF_LIST",
    "ADD_AGENT_STAFF",
    "VIEW_AGENT_STAFF",
    "EDIT_AGENT_STAFF",
    "ACTIVATE_AGENT_STAFF",
    "DEACTIVATE_AGENT_STAFF",
    "APPROVE_AGENT_STAFF",
    "REJECT_AGENT_STAFF",
    "RESET_AGENT_PASSWORD",
    "UNBLOCK_AGENT",
    "GET_AGENT_DETAILS",

    "ACCOUNT_LIST",
    "CREATE_ACCOUNT",
    "VIEW_ACCOUNT",
    "ACTIVATE_ACCOUNT",
    "DEACTIVATE_ACCOUNT",
    "APPROVE_ACCOUNT",
    "REJECT_ACCOUNT",
    "VIEW_AGENT_ACCOUNT",
    "GET_WAKALA_ACCOUNT_DETAILS",

    "API_LIST",
    "API_DETAILS",
    "VIEW_API",
    "ACTIVATE_API",
    "DEACTIVATE_API",
    "APPROVE_API",
    "REJECT_API",
    "GET_PARTNER_PROPERTIES",
    "CREATE_PARTNER_PROPERTY",
    "UPDATE_PARTNER_PROPERTY",
    "UPDATE_FSP_CODE",
    "UPDATE_OUTBOUND_CREDENTIALS",
    "DOWNLOAD_KEY",

    "MERCHANT_LIST",
    "ADD_MERCHANT",
    "VIEW_MERCHANT",
    "ACTIVATE_MERCHANT",
    "DEACTIVATE_MERCHANT",
    "MERCHANT_TRANSACTIONS",
    "VIEW_MERCHANT_TRANSACTION",
    "MERCHANT_PROPERTIES",
    "CREATE_MERCHANT_PROPERTY",
    "UPDATE_MERCHANT_PROPERTY",
    "DELETE_MERCHANT_PROPERTY",
    "CREATE_MERCHANT_ACCOUNT",
    "UPDATE_MERCHANT_ACCOUNT",

    "LIST_LOGS",
    "LIST_FOLDER_LOGS",
    "VIEW_LOG",

    "LIST_TARRIF",
    "CREATE_TARRIF",
    "UPDATE_TARRIF",
    "DELETE_TARRIF",
  ],
  suffixTypes,
);

// exports
export const ACTION_ACCOUNT_SETUP = "ACCOUNT_SETUP";
export const ACTION_ACCOUNT_REMOVE = "ACCOUNT_REMOVE";
export const ACTION_RESET_APP_STATE = "RESET_STATE";
